import {IForm} from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'environment',
      type: 'default',
      label: '数据库'
    },
    {
      field: 'username',
      type: 'input',
      label: '账号',
      placeholder: '请输入账号',
      rules: {required: true, message: '账号是必传的', trigger: 'blur'}
    },
    {
      field: 'password',
      type: 'input',
      label: '密码',
      placeholder: '请输入密码',
      rules: {required: true, message: '密码是必传的', trigger: 'blur'}
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
